/// <amd-module name="Widgets/VelocityWidget/VelocityWidgetComponents/VelocitySettingsManager" />
import { WidgetTeamContext } from "Dashboards/WidgetContracts/WidgetProps";
import * as TfsWidgetContext from "Tfs/Widget/Context";
import { IVssPageContext } from "VSS/Platform/Context";
import { AggregationMode, TeamScope } from "WidgetCommon/ModernWidgetTypes/CommonConfigurationTypes";
import { SettingsManagerBase } from "WidgetCommon/ModernWidgetTypes/SettingsManagerBase";
import { VelocityConstants } from "./VelocityConstants";
import { WorkItemTypeFilterMode } from "./VelocityDataContract";
import { AggregationSettings, VelocitySettings } from "./VelocitySettings";

export default class VelocitySettingsManager extends SettingsManagerBase<VelocitySettings> {
    public constructor(protected pageContext: IVssPageContext, protected teamContext: WidgetTeamContext) {
        super();
    }

    public getFeatureName() {
        return VelocityConstants.featureName;
    }

    /**
     * Provides promise to perform neccessary legwork to produce default Velocity Settings, if possible.
     */
    public generateDefaultSettings(): Promise<VelocitySettings> {
        const context = this.packContext(this.teamContext);
        return Promise.resolve(packSettings(context));
    }

    /** Collects neccessary initial information for querying for default settings. Decoupled from main method for testability. */
    private packContext(teamContext: WidgetTeamContext): TeamScope {
        return {
            teamId: teamContext.id,
            projectId: TfsWidgetContext.getProject(this.pageContext).id
        };
    }
}

/** Used by the SettingsManager, as well as Velocity Report Experience. Default values for aggregation settings and number of iterations will be assigned if not supplied. */
export function packSettings(
    context: TeamScope,
    defaultBacklogCategory?: string,
    aggregationSettings?: AggregationSettings,
    numberOfIterations?: number,
    showResolvedItemsAsCompleted = false
): VelocitySettings {
    const defaultSettings: VelocitySettings = {
        lastArtifactName: undefined,
        teamId: context.teamId,
        projectId: context.projectId,
        aggregation: aggregationSettings
            ? aggregationSettings
            : {
                  identifier: AggregationMode.Count,
                  settings: "" // empty settings can be passed in only with aggregation mode count
              },
        lateWorkDelay: 0,
        plannedWorkDelay: 0,
        numberOfIterations: numberOfIterations ? numberOfIterations : 6,
        workItemTypeFilter: {
            identifier: WorkItemTypeFilterMode[WorkItemTypeFilterMode.BacklogCategory],
            settings: defaultBacklogCategory ? defaultBacklogCategory : "Microsoft.RequirementCategory"
        },
        showResolvedItemsAsCompleted
    };

    return defaultSettings;
}
